import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { UserConsentsApi } from '../../../apis/UserConsentsApi/UserConsentsApi.ts';
import { IUserPreferences } from '../UserConsent.ts';

export function useUpdateAlertBellMinSeverity() {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, string>({
        mutationKey: [QueryKeys.userPreferences, 'updateAlertBellMinSeverity'],
        mutationFn: async (minSeverity: string) => {
            await UserConsentsApi.patchAlertBellMinSeverity({ minSeverity });
        },
        onSuccess: (_data, minSeverity) => {
            queryClient.setQueryData<IUserPreferences>(
                [QueryKeys.userPreferences],
                (prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        alertBellMinSeverity: minSeverity,
                    };
                },
            );

            queryClient.invalidateQueries({ queryKey: [QueryKeys.userPreferences] });
        },
        onError: (error) => {
            console.error('Error updating alert bell min severity:', error);
        },
    });
}
